import { getInventarCards } from "./thunks/userThunks"
import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  loading: false,
  error: "",
  isAuth: false,
  user: {
    userName: "User",
    address: "",
    ztd: 0,
    lockedZtd: 0,
    balance: 0,
    userId: null,
    sessionToken: null, // Добавляем поле для токена сессии
  },
  walletBalance: 0,
  cards: [],
}

const userSlice = createSlice({
  name: "user",

  initialState,

  reducers: {
    setUserName(state, action) {
      state.user.userName = action.payload
    },
    incrementBalance(state, action) {
      state.user.balance += action.payload
    },
    decrementBalance(state, action) {
      state.user.balance -= action.payload
    },
    setWalletBalance(state, action) {
      state.walletBalance = action.payload
    },
    setIsAuth(state, action) {
      state.isAuth = action.payload
    },
    setUserLoading(state, action) {
      state.loading = action.payload
    },
    setUser(state, action) {
      state.user = { ...state.user, ...action.payload }
      state.isAuth = !!action.payload.address // Авторизация при наличии адреса
    },
    // Добавляем новый action для очистки пользователя
    clearUser(state) {
      state.user = {
        userName: "User",
        address: "",
        ztd: 0,
        lockedZtd: 0,
        balance: 0,
        userId: null,
        sessionToken: null,
      }
      state.isAuth = false
      state.walletBalance = 0
    },
    // Добавляем action для установки только адреса (для обратной совместимости)
    setUserAddress(state, action) {
      state.user.address = action.payload
      state.isAuth = !!action.payload
    },
  },
  extraReducers: {
    [getInventarCards.fulfilled.type]: (state, action) => {
      state.loading = false
      // Добавляем проверку на существование данных
      state.cards = action.payload?.data || []
      state.error = ""
    },
    [getInventarCards.pending.type]: (state, action) => {
      state.loading = true
    },
    [getInventarCards.rejected.type]: (state, action) => {
      state.loading = false
      state.error = action.payload || "Произошла ошибка"
    },
  },
})

export default userSlice.reducer
export const {
  setUserName,
  setUser,
  setUserAddress, // Экспортируем новый action
  incrementBalance,
  setUserLoading,
  setWalletBalance,
  decrementBalance,
  setIsAuth,
  clearUser, // Экспортируем action для очистки
} = userSlice.actions
